import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../hooks/store-hooks";
import {
  AppBar,
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  debounce,
  Dialog,
  Divider,
  Grid,
  Skeleton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import {
  useProjetosService,
  useRecortesExtracaoService,
} from "../../../../../use-cases/geo-veles";
import { theme } from "../../../../styles";
import { CreateRecorteProjetoForm } from "./create-recorte-projeto-form";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import DownloadIcon from "@mui/icons-material/Download";
import { RecortesProjetoList } from "./recortes-projeto-list";
import { useLayoutRecorteExtracaoService } from "../../../../../use-cases/geo-veles/layout-recortes";
import {
  ILayoutRecorteTable,
  ITipoUsuario,
} from "../../../../../application/models";
import { LayoutRecortes } from "./LayoutRecortes";

export const RecortesDoProjeto = () => {
  // Use State
  const [loading, setLoading] = useState<boolean>(true);

  // Use App Selector
  const travaConsumo = useAppSelector((state) => state.travaConsumo);
  const user = useAppSelector((state) => state.user);
  const auth = useAppSelector((state) => state.auth);
  const access = useAppSelector((state) => state.user.access);
  const { Layouts, layoutRecorteSelecionado } = useAppSelector(
    (state) => state.layoutRecorte
  );



  const { projetoAberto, relatorioProjeto, createExtracaoForm } =
    useAppSelector((state) => state.projetos);

  const {
    openForm,
    createOpenForm,
    recorteExtracao,
    downloadLocked,
    
  } = useAppSelector((state) => state.recorteExtracao);

  // Hook
  const {
    resetRecorteExtracao,
    openCreateRecorteForm,
    resetCreateRecorteForm,
    analiseRecorteExtracao,
    setRecorteExtracao,
    resetRecorteEditando,
    setCreateRecorteFormNome,
  } = useRecortesExtracaoService();

  const {
    setCreateLayoutRecorteFormOpen,
    getLayoutsRecorteByIdUsuario,
    setLayoutRecorteSelecionado,
    resetLayoutSelecionado,
  } = useLayoutRecorteExtracaoService();

  const {
    createExtracao,
    verifyTravaConsumo,
    setCreateExtracaoFormQuantidade,
    setVerifyAcesso,
    resetRelatorioProjeto,
    setCreateExtracaoFormNome,
  } = useProjetosService();
  const navigate = useNavigate();
  // Ref to prevent multiple calls
  const hasFetched = useRef(false);

  // Variáveis
  let idProjeto: number = projetoAberto?.IdVelesGeoProjeto ?? 0;
  let qtdDigitada: number = 0;

  let quantidadeMaximaCliente: number = 0;
  let quantidadeMaximaUsuario: number = 0;
  let quantidadeMaxima: number =
    travaConsumo.data.quantidadeMaximaExtracaoPermitadaPorUsuarioExcetoVendedor;
  let labelTravaConsumoUsuario: string = "";
  let labelTravaConsumoUsuarioConsumiu: string = "";
  let labelTravaConsumoCliente: string = "";
  let labelTravaConsumoClienteConsumiu: string = "";

  if (travaConsumo.data.travaConsumo.UsuarioTravaQuantidade > 0) {
    quantidadeMaximaUsuario =
      travaConsumo.data.travaConsumo.UsuarioTravaQuantidade -
      travaConsumo.data.travaConsumo.UsuarioConsumiu;
    labelTravaConsumoUsuario = `Quantidade de registros permitidos para extração do usuário <strong>${user.currentUser?.LoginUsuario}</strong>: <strong>${quantidadeMaximaUsuario}</strong>`;
    labelTravaConsumoUsuarioConsumiu = `Quantidade de registros consumidos pelo usuário <strong>${user.currentUser?.LoginUsuario}</strong>: <strong>${travaConsumo.data.travaConsumo.UsuarioConsumiu}</strong>`;
  }

  // Verifica a trava de consumo do cliente
  if (travaConsumo.data.travaConsumo.ClienteTravaQuantidade > 0) {
    quantidadeMaximaCliente =
      travaConsumo.data.travaConsumo.ClienteTravaQuantidade -
      travaConsumo.data.travaConsumo.ClienteConsumiu;
    labelTravaConsumoCliente = `Quantidade de registros permitidos para extração do cliente <strong>${auth.loginForm.fields.loginCliente}</strong>: <strong>${quantidadeMaximaCliente}</strong>`;
    labelTravaConsumoClienteConsumiu = `Quantidade de registros consumidos pelo cliente <strong>${auth.loginForm.fields.loginCliente}</strong>: <strong>${travaConsumo.data.travaConsumo.ClienteConsumiu}</strong>`;
  }

  // Se o usuário e o cliente não tiverem trava, mantém a variável quantidadeMaximaCliente e quantidadeMaximaUsuario
  if (
    travaConsumo.data.travaConsumo.UsuarioTravaQuantidade === 0 &&
    travaConsumo.data.travaConsumo.ClienteTravaQuantidade === 0
  ) {
    quantidadeMaximaCliente = quantidadeMaxima;
    quantidadeMaximaUsuario = quantidadeMaxima;
  }

  useEffect(() => {


    if (!recorteExtracao || recorteExtracao.IdVelesGeoProjeto === 0) {
      idProjeto = projetoAberto?.IdVelesGeoProjeto ?? 0;
    } else {
      if (
        projetoAberto?.IdVelesGeoProjeto === 0 ||
        projetoAberto?.IdVelesGeoProjeto === undefined
      ) {
        idProjeto = recorteExtracao?.IdVelesGeoProjeto ?? 0;
      }
    }
  });

  let findLayout: ILayoutRecorteTable | undefined = undefined;

  useEffect(()=> {
  })

  useEffect(() => {
    if (idProjeto && !hasFetched.current) {
      setLoading(false);
      hasFetched.current = true;
    }
  }, [idProjeto]);

  useEffect(() => {
    verifyTravaConsumo({
      IdCliente: user.currentUser?.IdCliente ?? 0,
      IdUsuario: user.currentUser?.IdUsuario ?? 0,
    });
  }, [user.currentUser?.IdCliente, user.currentUser?.IdUsuario, verifyTravaConsumo]);

  useEffect(() => {
    if (!projetoAberto) {
      const idProjetoLocalStorage =
        Number(localStorage.getItem("idProjeto")) || 0;
      if (!recorteExtracao) {
        navigate(`/geo-veles/projetos/${idProjetoLocalStorage}`);
      }
    } else {
      // Pegando o IdVelesGeoProjeto do state e armazenando na localStorage
      idProjeto = projetoAberto?.IdVelesGeoProjeto ?? 0;
      localStorage.setItem("idProjeto", idProjeto.toString());

      resetRecorteExtracao();
      resetLayoutSelecionado();
      setRecorteExtracao();
    }
  }, [projetoAberto]);

  useEffect(() => {

    if (projetoAberto) {
      setCreateExtracaoFormNome(projetoAberto?.Nome);
    } else {
      setCreateExtracaoFormNome("");
    }
  }, []);

  useEffect(() => {
    if (!access) {
      setVerifyAcesso();
    }
  }, [setVerifyAcesso, access]);

  // Functions
  function closeDialog() {
    navigate(`/geo-veles/projetos/${idProjeto}`);
    resetRelatorioProjeto();
    resetRecorteExtracao();
    openCreateRecorteForm(false);
  }
  useEffect(() => {
    if (qtdDigitada > 0) {
      setCreateExtracaoFormQuantidade(String(qtdDigitada));
    }
  });

  useEffect(() => {
    setCreateRecorteFormNome(
      String(projetoAberto?.Nome) ?? ""
    );

    getLayoutsRecorteByIdUsuario(user.currentUser?.IdUsuario ?? 0);
  }, [getLayoutsRecorteByIdUsuario]);

  const debouncedNome = debounce(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setCreateExtracaoFormNome(e.target.value);
    },
    500
  );

  return (
    <>
      <Dialog open={true} onClose={closeDialog} fullScreen disableEscapeKeyDown>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography
              sx={{ ml: 2, flex: 1 }}
              textTransform={"uppercase"}
              variant="h6"
              component="div"
            >
              {loading ? (
                <Skeleton animation="wave" variant="text" width={400} />
              ) : (
                <>
                  Detalhamento das extrações - Projeto{" "}
                  <strong>{projetoAberto?.Nome ?? ""}</strong>
                </>
              )}
            </Typography>
            <Button
              color="inherit"
              onClick={closeDialog}
              aria-label="close"
              sx={{
                fontWeight: "bold",
              }}
            >
              Fechar
            </Button>
          </Toolbar>
        </AppBar>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          p={2}
        >
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={10}>
              <Typography
                variant="h6"
                color="primary"
                fontWeight="bold"
                textTransform="uppercase"
                textAlign="center"
              >
                Nome
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <TextField
                onChange={debouncedNome}
                error={Boolean(
                  createExtracaoForm.touched &&
                    createExtracaoForm.errors.find(
                      (item) => item.key === "nome"
                    )
                )}
                helperText={
                  createExtracaoForm.errors.find((item) => item.key === "nome")
                    ?.message
                }
                name="nome"
                fullWidth
                id="nome"
                label="Nome da Exportação"
                defaultValue={
                  createExtracaoForm.fields.nome ?? ""
                  // " - " +
                  // new Date().toLocaleDateString("pt-br")
                }
              />
            </Grid>
            <br />

            <Grid container item xs={12} alignItems="stretch">
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  color="primary"
                  fontWeight="bold"
                  textTransform="uppercase"
                  textAlign="center"
                >
                  Filtros | Quantidades
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={10} mb={2}>
              <Divider variant="middle" color={theme.palette.primary.main} />
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="text"
                endIcon={
                  openForm && createOpenForm ? <RemoveIcon /> : <AddIcon />
                }
                onClick={() => {
                  if (openForm && createOpenForm) {
                    resetCreateRecorteForm();
                    openCreateRecorteForm(false);
                  } else {
                    openCreateRecorteForm(true);
                  }
                }}
              >
                {openForm && createOpenForm
                  ? "Descartar recorte"
                  : "Adicionar novo recorte"}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                fullWidth
                variant="text"
                endIcon={<AddIcon />}
                onClick={() => {
                  setCreateLayoutRecorteFormOpen(true);
                }}
              >
                {"Criar novo layout de recorte"}
              </Button>
            </Grid>

            <Grid item xs={10}>
              <Divider variant="middle" color={theme.palette.primary.main} />
            </Grid>

            <Grid item xs={10} display={"flex"} mt={2}>
              {openForm && createOpenForm && <CreateRecorteProjetoForm />}
            </Grid>

            <Grid item xs={10}>
              <Autocomplete
                key={layoutRecorteSelecionado?.IdVelesGeoLayoutRecorte ?? 0}
                isOptionEqualToValue={(option, value) =>
                  option.IdVelesGeoLayoutRecorte ===
                  value?.IdVelesGeoLayoutRecorte
                }
                getOptionLabel={(option) => `Nome: ${option.NomeLayout}`}
                getOptionKey={(option) => option.IdVelesGeoLayoutRecorte}
                renderInput={(props) => (
                  <TextField
                    {...props}
                    label={
                      "Digite ou clique aqui para selecionar um layout de recorte"
                    }
                    value={
                      layoutRecorteSelecionado?.NomeLayout.toString() ??
                      "Digite ou clique aqui para selecionar um layout de recorte"
                    }
                  />
                )}
                noOptionsText={"Nenhum layout disponível"}
                options={Layouts}
                value={layoutRecorteSelecionado}
                onChange={(
                  event: any,
                  newValue: ILayoutRecorteTable | null
                ) => {
                  if (newValue) {
                    findLayout = Layouts.find(
                      (layout) =>
                        layout.IdVelesGeoLayoutRecorte ===
                        newValue.IdVelesGeoLayoutRecorte
                    );
                    if (findLayout) {
                      resetRecorteEditando();

                      setLayoutRecorteSelecionado({
                        layout: findLayout,
                        idVelesGeoProjeto: idProjeto,
                      });
                    }
                  } else {
                    resetLayoutSelecionado();
                  }
                }}
              />
              <Grid item xs={10}>
                <Typography>
                  <br />
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  color="primary"
                  fontWeight="bold"
                  textTransform="uppercase"
                  textAlign="center"
                >
                  {layoutRecorteSelecionado
                    ? "Layout de recortes selecionado"
                    : "Recortes do projeto atual"}
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={10} mb={2}>
              <Divider variant="middle" color={theme.palette.primary.main} />
            </Grid>
            <Grid item xs={10} mb={3}>
              {layoutRecorteSelecionado?.Recortes ? (
                <LayoutRecortes />
              ) :
              recorteExtracao &&
                Array.isArray(recorteExtracao.Recortes) &&
                recorteExtracao.Recortes.length > 0 ? (
                <RecortesProjetoList
                  temRecorteExtracao={recorteExtracao}
                  modoSomenteLeitura={false}
                />
              ) : (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  fontWeight="bold"
                  textTransform="uppercase"
                  textAlign="center"
                >
                  Nenhum recorte encontrado no momento.
                </Typography>
              )}
            </Grid>
            <Grid item xs={10}>
              <Card
                sx={{
                  marginBottom: 4,
                  marginTop: -2,
                  backgroundColor: "#f9f9f9",
                }}
              >
                <CardHeader
                  align="center"
                  title="Informações"
                  fontWeight="bold"
                  titleTypographyProps={{
                    component: Typography,
                    color: "primary",
                    textTransform: "uppercase",
                    align: "center",
                    fontWeight: "bold",
                    variant: "h6",
                  }}
                />
                <CardContent>
                  <Typography>
                    <span>
                      Quantidade registros para a extração do projeto :{" "}
                      <strong>
                        {relatorioProjeto?.dados.disponiveis.toLocaleString(
                          "pt-br"
                        )}
                      </strong>
                    </span>{" "}
                    <br />
                    <span>
                      Quantidade máxima de registros permitido(s) para extração
                      pela plataforma :{" "}
                      <strong>
                        {travaConsumo.data.quantidadeMaximaExtracaoPermitadaPorUsuarioExcetoVendedor.toLocaleString(
                          "pt-br"
                        )}{" "}
                      </strong>
                    </span>{" "}
                    <br />
                  </Typography>
                </CardContent>
              </Card>
              <Card
                hidden={
                  user.currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_COMERCIAL &&
                  (user.currentUser?.IdCliente === 1 ||
                    (travaConsumo.data.travaConsumo.ClienteTravaQuantidade ===
                      0 &&
                      travaConsumo.data.travaConsumo.UsuarioTravaQuantidade ===
                        0))
                }
                sx={{ backgroundColor: "#f9f9f9" }}
              >
                <CardHeader
                  align="center"
                  title="Trava de consumo"
                  fontWeight="bold"
                  titleTypographyProps={{
                    component: Typography,
                    color: "primary",
                    textTransform: "uppercase",
                    align: "center",
                    fontWeight: "bold",
                    variant: "h6",
                  }}
                />
                <CardContent>
                  <Typography>
                    {/* Exibe a linha do vendedor se for o caso */}
                    {travaConsumo.data.travaConsumo.UsuarioTravaQuantidade >
                      0 && (
                      <>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: labelTravaConsumoUsuario,
                          }}
                        ></span>
                        <br />
                        <span
                          dangerouslySetInnerHTML={{
                            __html: labelTravaConsumoUsuarioConsumiu, 
                          }}
                        ></span>
                        <br />
                      </>
                    )}

                    {/* Se o cliente tiver a trava de consumo, exibe as informações do cliente */}
                    {travaConsumo.data.travaConsumo.ClienteTravaQuantidade >
                      0 && (
                      <>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: labelTravaConsumoCliente,
                          }}
                        ></span>
                        <br />
                        <span
                          dangerouslySetInnerHTML={{
                            __html: labelTravaConsumoClienteConsumiu,
                          }}
                        ></span>
                        <br />
                      </>
                    )}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={4}>
              <Button
                disabled={!recorteExtracao?.Recortes?.length} 
                variant="contained"
                color="primary"
                fullWidth
                endIcon={<QueryStatsIcon />}
                onClick={() => analiseRecorteExtracao()}
              >
                Analisar recortes
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                disabled={!recorteExtracao?.Recortes?.length || downloadLocked}
                variant="contained"
                color="primary"
                fullWidth
                endIcon={<DownloadIcon />}
                onClick={createExtracao}
              >
                Iniciar exportação
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </>
  );
};
